export default __webpack_public_path__ + "static/media/Soulharrow.6e68f4ed.jpg";